// muiHowItWorksStyles.tsx
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import WSprites from '../../assets/images/sprites/wsprite.png';

// Next/Webpack may export either a string or an object with .src
const SPRITE_URL = (WSprites as any)?.src ?? (WSprites as unknown as string);

// ----- Types
export interface HowItWorksBGImageProp {
  imageName?: 'spend-earn' | 'arrow' | 'use-points' | string;
}

// ----- HowItWorksBGImage (sprite-based)
export const HowItWorksBGImage = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'imageName',
})<HowItWorksBGImageProp>(({ imageName }) => {
  const base = {
    backgroundImage: `url("${SPRITE_URL}")`,
    backgroundRepeat: 'no-repeat',
  } as const;

  switch (imageName) {
    case 'spend-earn':
      return {
        ...base,
        backgroundPosition: '-1127px -93px',
        width: 215,
        height: 119,
      };
    case 'arrow':
      return {
        ...base,
        backgroundPosition: '-1127px -756px',
        width: 213,
        height: 55,
        '@media only screen and (min-width: 992px)': {
          backgroundPosition: '-1127px 0px',
          width: 338,
          height: 88,
        },
      };
    case 'use-points':
      return {
        ...base,
        backgroundPosition: '-1127px -217px',
        width: 154,
        height: 134,
      };
    default:
      // original always applied background-image; leaving base preserves that
      return base;
  }
});

// ----- Containers & elements
export const HowItWorksBGImageContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});

export const HowItWorksImage = styled('img')({
  width: 72,
  height: 72,
});

export const HowItWorksImagesWrapper = styled(Box)({
  margin: '30px auto 20px',
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  columnGap: 10,

  '@media only screen and (min-width: 768px)': {
    gridTemplateColumns: 'repeat(3, 1fr)',
    margin: '10px auto 20px 20px',
    maxWidth: 700,
  },

  '@media only screen and (min-width: 992px)': {
    maxWidth: 900,
  },
});

export const HowItWorksText = styled(Box)({
  flex: 1,

  '& h3': {
    margin: '0 0 5px',
    '@media only screen and (min-width: 992px)': {
      fontSize: 28,
    },
  },

  '& p': {
    margin: 0,
    lineHeight: 1.3,
  },
});

export const HowItWorksItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 15,
  marginBottom: 20,

  '@media only screen and (min-width: 768px)': {
    marginBottom: 30,
  },
});
